<template>
  <head>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css" rel="stylesheet">
  </head>
  
  <!-- Yükleme Barı -->
  <div v-if="loadingPersonalData" class="loading-overlay">
    <div class="loading-content">
      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Yükleniyor...</span>
      </div>
      <p class="mt-3">Güncelleniyor, lütfen bekleyiniz...</p>
      <div class="progress mt-2" style="width: 300px;">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 100%"></div>
      </div>
    </div>
  </div>

  <!-- Personel Listesi Yükleniyor -->
  <div v-if="isLoadingPersonalList" class="loading-overlay">
    <div class="loading-content">
      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Yükleniyor...</span>
      </div>
      <p class="mt-3">Personeller yükleniyor, lütfen bekleyiniz...</p>
      <div class="progress mt-2" style="width: 300px;">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 100%"></div>
      </div>
    </div>
  </div>

  <div style="padding: 10px; margin-bottom: 20px;">
    <div class="shadow-box">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h6 class="mb-0">Personel Seç</h6>
      </div>

      <div class="d-flex align-items-center gap-2 position-relative">
        <input
            type="text"
            class="form-control"
            style="max-width: 300px; max-height: 250px;"
            v-model="query"
            @input="filterItems"
            @focus="showSuggestions = true"
            @blur="hideSuggestions"
            :disabled="isLoadingPersonalList"
        />
        <button style="margin-top: 6px;" type="button" class="btn btn-primary" @click="addPersonal" :disabled="isLoadingPersonalList">Ekle</button>
      </div>

      <div class="mt-3">
        <a href="/definitions-personal" style="color: #0d6efd;">Personel Tanımla</a>
      </div>

      <ul
          v-if="showSuggestions && filteredItems.length"
          class="list-group mt-1 position-absolute zindex-dropdown"
          style="width: 300px; max-height: 200px; overflow-y: auto;"
      >
        <li
            v-for="item in filteredItems"
            :key="item.id"
            @mousedown="selectItem(item)"
            class="list-group-item list-group-item-action"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>

  <div v-if="selectedPersonal && selectedPersonal.length > 0" class="personalExpensesDiv" v-for="(val, index) in selectedPersonal" :key="val.id">
    <div class="row">
      <p class="d-flex">
      <span class="centered-text">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="personal-info">
            <b>Ad Soyad: </b> {{ val.name }} &nbsp; &nbsp;
            <b>Rolü: </b> {{ val.personalExpenses?.personal?.role?.roleName || 'Bilinmiyor' }} &nbsp; &nbsp;
            <b>Çalışma Durumu: </b> {{ val.personalExpenses?.personal?.workOrRetired ? 'Emekli' : 'Çalışıyor' }} &nbsp; &nbsp;
            <b>Çalışma Tipi: </b> {{ val.personalExpenses?.personal?.workType ? 'Tam Zamanlı' : 'Yarı Zamanlı' }} &nbsp; &nbsp;
            <br>
            <b>İçe Görevlendirme Saati: </b>{{ val.personalWorkedHours || '0' }} &nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
            <b>Aktif Sözleşme Saati: </b> {{ val.activeContractHours|| '0' }} &nbsp; &nbsp;
            <b>Ortalama Saatlik Ücret:</b> {{ (val.averagehourlyrate || 0).toFixed(2) }} ₺
          </div>
      <button
          type="button"
          class="btn btn-outline-primary load-contracts-btn"
          @click="togglePreviousContracts(val.personalExpenses?.personal?.id || val.id, index)"
      >
        <i class="bi"
           :class="{'bi-chevron-down': !isContractsVisible(index), 'bi-chevron-up': isContractsVisible(index)}">
        </i>
        Geçmiş Sözleşmeleri {{ isContractsVisible(index) ? 'Gizle' : 'Göster' }}
      </button>
           &nbsp;&nbsp;
          <button
              type="button"
              class="btn btn-outline-primary load-contracts-btn"
              @click="toggleActiveContracts(val.personalExpenses?.personal?.id || val.id, index)"
          >
    <i class="bi"
       :class="{'bi-chevron-down': !isActiveContractsVisible(index), 'bi-chevron-up': isActiveContractsVisible(index)}">
    </i>
    Aktif Sözleşmeleri {{ isActiveContractsVisible(index) ? 'Gizle' : 'Göster' }}
</button>
    </div>
</span>

        <button
            class="btn btn-link"
            @click="toggleCollapse(index)"
            :aria-expanded="isCollapsed(index) ? 'false' : 'true'"
            style="border: none; background: transparent;">
          <i v-if="isCollapsed(index)" class="bi bi-chevron-down" style="font-size: 20px;"></i>
          <i v-else class="bi bi-chevron-up" style="font-size: 20px;"></i>
        </button>
      </p>
    </div>

    <div v-if="isContractsVisible(index)" class="contracts-container mt-3">
      <div v-if="val.loadingPreviousContracts" class="text-center py-3">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Yükleniyor...</span>
        </div>
        <p class="mt-2">Geçmiş sözleşmeler yükleniyor...</p>
      </div>


      <div v-else-if="Array.isArray(val.previousContracts) && val.previousContracts.length > 0" class="previous-contracts">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="table-light">
            <tr>
              <th>Sözleşme Adı</th>
              <th>Sözleşme Tutarı</th>
              <th>Başlangıç Tarihi</th>
              <th>Bitiş Tarihi</th>
              <th>Çalışma Saati</th>
              <th>Saatlik Brüt Ücret</th>
              <th>Aylık Brüt Ücret</th>
              <th>Yemek Gideri</th>
              <th>Araç Gideri</th>
              <th>Yakıt Gideri</th>
              <th>Diğer Giderler</th>
              <th>Seyahat Gideri</th>
              <th>Kıdem Yükü</th>
              <th>İkame Hizmeti</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="contract in val.previousContracts" :key="contract.id">
              <td>{{ contract.contracts?.contractName }}</td>
              <td>{{ formatCurrency(contract.contracts?.contractPrice) }}</td>
              <td>{{ formatDate(contract.personalStartDate) }}</td>
              <td>{{ formatDate(contract.personalEndDate) }}</td>
              <td>{{ contract.workedHours }} Saat</td>
              <td>{{ formatCurrency(contract.hoursNetAmount)}}</td>
              <td>{{ formatCurrency(contract.monthNetAmount)}}</td>
              <td>{{ formatCurrency(contract.foodExpenses) }}</td>
              <td>{{ formatCurrency(contract.carRentExpenses) }}</td>
              <td>{{ formatCurrency(contract.fuelExpenses) }}</td>
              <td>{{ formatCurrency(contract.otherExpenses) }}</td>
              <td>{{ formatCurrency(contract.travelExpenses) }}</td>
              <td>{{ contract.seniorityBurden ? 'Müşteri' : 'Artı' }}</td>
              <td>{{ contract.replacementService ? 'Evet' : 'Hayır' }}</td>
            </tr>
            <tr v-if="val.previousContracts && val.previousContracts.length" class="total-row">
              <td colspan="4"><strong>Toplam:</strong></td>
              <td colspan="3"></td>
              <td><strong>{{ formatCurrency(calculateTotalFoodExpenses(val.id)) }}</strong></td>
              <td><strong>{{ formatCurrency(calculateTotalCarRentExpenses(val.id)) }}</strong></td>
              <td><strong>{{ formatCurrency(calculateTotalFuelExpenses(val.id)) }}</strong></td>
              <td><strong>{{ formatCurrency(calculateTotalOtherExpenses(val.id)) }}</strong></td>
              <td><strong>{{ formatCurrency(calculateTotalTravelExpenses(val.id)) }}</strong></td>
              <td colspan="2"></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else class="text-center py-3">
        <div class="d-flex flex-column align-items-center">
          <i class="bi bi-info-circle text-muted fs-4 mb-2"></i>
          <p class="text-muted mb-0">Bu personele ait geçmiş sözleşme bulunmamaktadır.</p>
        </div>
      </div>



    </div>

    <div v-if="isActiveContractsVisible(index)" class="contracts-container mt-3">
      <div v-if="activeContractsData[index] && activeContractsData[index].length > 0" class="active-contracts">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="table-light">
            <tr>
              <th>Sözleşme Adı</th>
              <th>Sözleşme Tutarı</th>
              <th>Başlangıç Tarihi</th>
              <th>Bitiş Tarihi</th>
              <th>Çalışma Saati</th>
              <th>Saatlik Brüt Ücret</th>
              <th>Aylık Brüt Ücret</th>
              <th>Yemek Gideri</th>
              <th>Araç Gideri</th>
              <th>Yakıt Gideri</th>
              <th>Diğer Giderler</th>
              <th>Seyahat Gideri</th>
              <th>Kıdem Yükü</th>
              <th>İkame Hizmeti</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="contract in activeContractsData[index]" :key="contract.id">
              <td>{{ contract.contractname }}</td>
              <td>{{ formatCurrency(contract.contractprice) }}</td>
              <td>{{ formatDate(contract.personalstartdate) }}</td>
              <td>{{ formatDate(contract.personalenddate) }}</td>
              <td>{{ contract.workedhours }} Saat</td>
              <td>{{ formatCurrency(contract.hoursnetamount) }}</td>
              <td>{{ formatCurrency(contract.monthnetamount) }}</td>
              <td>{{ formatCurrency(contract.foodexpenses) }}</td>
              <td>{{ formatCurrency(contract.carrentexpenses) }}</td>
              <td>{{ formatCurrency(contract.fuelexpenses) }}</td>
              <td>{{ formatCurrency(contract.otherexpenses) }}</td>
              <td>{{ formatCurrency(contract.travelexpenses) }}</td>
              <td>{{ contract.seniorityburden ? 'Müşteri' : 'Artı' }}</td>
              <td>{{ contract.replacementservice ? 'Evet' : 'Hayır' }}</td>
            </tr>
            <tr class="total-row">
              <td colspan="4"><strong>Toplam:</strong></td>
              <td colspan="3"></td>
              <td><strong>{{ calculateActiveContractTotalFoodExpenses(activeContractsData[index]) }}</strong></td>
              <td><strong>{{ calculateActiveContractTotalCarRentExpenses(activeContractsData[index]) }}</strong></td>
              <td><strong>{{ calculateActiveContractTotalFuelExpenses(activeContractsData[index]) }}</strong></td>
              <td><strong>{{ calculateActiveContractTotalOtherExpenses(activeContractsData[index]) }}</strong></td>
              <td><strong>{{ calculateActiveContractTotalTravelExpenses(activeContractsData[index]) }}</strong></td>
              <td colspan="2"></td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>

      <div v-else class="text-center py-3">
        <div class="d-flex flex-column align-items-center">
          <i class="bi bi-info-circle text-muted fs-4 mb-2"></i>
          <p class="text-muted mb-0">Bu personele ait aktif sözleşme bulunmamaktadır.</p>
        </div>
      </div>
    </div>



    <div v-show="!isCollapsed(index)">
      <hr>
      <div class="container  mb-3">
        <div class="row mb-3">
          <div class="col-3">
            <label class="form-check-label" :for="'personalStartDate' + index">
              Görev Başlangıç
            </label>
            <input
                class="form-control"
                type="date"
                :id="'personalStartDate' + index"
                v-model="selectedPersonal[index].personalStartDate"
            />
          </div>

          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Çalışma Saati</label>
            <input
                type="number"
                class="form-control"
                v-model.number="selectedPersonal[index].workTime"
                :max="selectedPersonal[index].personalworkedhours - selectedPersonal[index].workedhours"
                id="exampleFormControlInput1"
                placeholder="Çalışma Saati"
                step="1"
                min="0"
                @input="(e) => validateInput(e, index)"
            />
            <span class="text-muted">
                Maksimum: {{ calculateMaxWorkTime(index) }}
            </span>
          </div>





          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Saatlik Brüt Ücret</label>
            <input
                type="number"
                class="form-control"
                v-model="selectedPersonal[index].netHourAmount"
                id="exampleFormControlInput1"
                placeholder="Diğer Giderler"
                step="5.2"
            />
          </div>

          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Aylık Brüt Ücret</label>
            <input
                type="number"
                class="form-control"
                :value="getTotalAmount(index)"
                id="exampleFormControlInput1"
                placeholder="Diğer Giderler"
                readonly
            />
          </div>

        </div>




        <div class="row mb-3">
          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Kıdem Yükü</label>
            <select class="form-select" v-model="selectedPersonal[index].seniorityBurden" aria-label="Firmalar">
              <option :value="true">Müşteri</option>
              <option :value="false">Artı</option>
            </select>
          </div>






          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Sgk Günü</label>
            <input
                type="number"
                class="form-control"
                v-model.number="selectedPersonal[index].insuranceDay"
                id="exampleFormControlInput1"
                placeholder="Sgk Günü"
                min="0"
                step="1"
            />
          </div>


          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Sgk Matrah</label>
            <input
                type="number"
                class="form-control"
                :value="calculateSgkBasis(selectedPersonal[index].netMonthAmount || 0)"
                id="exampleFormControlInput1"
                placeholder="Sgk Matrah"
                step="0.01"
                readonly
            />
          </div>





          <div class="col-3">
            <label for="sgkRateSelect" class="form-label">SGK Oranı</label>
            <select
                id="sgkRateSelect"
                class="form-select"
                v-model="selectedPersonal[index].insuranceRate"
            >
              <option value="" disabled>SGK Oranı Seçiniz</option>
              <option
                  v-for="rate in sgkRateData"
                  :key="rate.id"
                  :value="rate.id"
              >
                {{ rate.sgkRate }}% - {{ rate.description }}
              </option>
            </select>
          </div>


        </div>





        <div class="row mb-3">
          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">İkame Hizmeti</label>
            <select class="form-select" v-model="selectedPersonal[index].replacementService" aria-label="Firmalar">
              <option :value="true">Evet</option>
              <option :value="false">Hayır</option>
            </select>
          </div>

          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Araç Kirası Gideri</label>
            <input
                type="number"
                class="form-control"
                v-model="selectedPersonal[index].carRentExpenses"
                id="exampleFormControlInput1"
                placeholder="Araç Kirası Gideri"
                step="5.2"
            />
          </div>

          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Yakıt Gideri</label>
            <input
                type="number"
                class="form-control"
                v-model="selectedPersonal[index].fuelExpenses"
                id="exampleFormControlInput1"
                placeholder="Yakıt Gideri"
                step="5.2"
            />
          </div>

          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Yol Gideri</label>
            <input
                type="number"
                class="form-control"
                v-model="selectedPersonal[index].travelExpenses"
                id="exampleFormControlInput1"
                placeholder="Yol Gideri"
                step="5.2"
            />
          </div>

        </div>





        <div class="row mb-3">










          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Yemek Gideri</label>
            <input
                type="number"
                class="form-control"
                v-model="selectedPersonal[index].foodExpenses"
                id="exampleFormControlInput1"
                placeholder="Yemek Gideri"
                step="5.2"
            />
          </div>

          <div class="col-3">
            <label for="exampleFormControlInput1" class="form-label">Diğer Giderler</label>
            <input
                type="number"
                class="form-control"
                v-model="selectedPersonal[index].otherExpenses"
                id="exampleFormControlInput1"
                placeholder="Diğer Giderler"
                step="5.2"
            />
          </div>

          <div class="col-3">
            <label class="form-check-label" :for="'personalEndDate' + index">
              Görev Bitiş
              <small class="text-muted ms-1">(Boş bırakılabilir)</small>
            </label>
            <input
                class="form-control"
                type="date"
                :id="'personalEndDate' + index"
                v-model="selectedPersonal[index].personalEndDate"
            />
          </div>

          <div class="col-3">
            <label for="invoiceAmount" class="form-label">Fatura Tutarı</label>
            <input
                type="number"
                class="form-control"
                v-model="selectedPersonal[index].invoiceAmount"
                id="invoiceAmount"
                placeholder="Fatura Tutarı"
                step="0.01"
                min="0"
            />
          </div>

        </div>

        <!-- Butonlar için yeni satır -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-end mt-3">
              <button
                  v-if="!selectedPersonal[index]?.personalExpenses?.id"
                  class="btn btn-secondary me-2"
                  @click="removeCard(index)"
              >Vazgeç</button>

              <!--
              <button
                  v-if="selectedPersonal[index]?.personalExpenses?.id"
                  class="btn btn-danger me-2"
                  @click="deleteExpense(index)"
              >
                Sözleşmeyi Bitir
              </button>
              -->

              <button
                  class="btn btn-primary"
                  @click="saveChanges(index)"
              >
                {{ selectedPersonal[index]?.personalExpenses?.id ? 'Güncelle' : 'Ekle' }}
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

    <!--
    <div class="row" style="margin-top:12px;" v-if="val.expensesTotal">
      <div class="table-responsive">
        <h6>Personel Detay</h6>
        <hr>
        <table class="table align-middle">
          <thead>
          <tr>
            <td>Firma</td>
            <td>Sözleşme adı</td>
            <td>İkame Hizmeti</td>
            <td>Kıdem Yükü</td>
            <td>Görev Başlangıç</td>
            <td>Görev Bitiş</td>
            <td>Çalışma Süresi</td>
            <td>Saatlik Brüt ücret</td>
            <td>Aylık Brüt ücret</td>
            <td>Yol Gideri</td>
            <td>Yemek Gideri</td>
            <td>Yakıt Gideri</td>
            <td>Araç Gideri</td>
            <td>Diğer Giderler</td>
          </tr>
          </thead>

          <tbody>
          <tr v-for="val in JSON.parse(val.personalExpenses)" v-bind:key="val.id">
            <td class="text-center">{{val.company}}</td>
            <td class="text-center">{{val.contract}}</td>
            <td class="text-center">
              <div v-if="val.replacement_service === true">Var</div>
              <div v-if="val.replacement_service === false">Yok</div>
            </td>
            <td class="text-center">
              <div v-if="val.seniority_burden === true">Müşteri</div>
              <div v-if="val.seniority_burden === false">Artı</div>
            </td>
            <td>{{val.personal_start_date}}</td>
            <td>{{val.personal_end_date}}</td>
            <td class="text-center">{{val.worked_hours}}</td>
            <td class="text-center">{{val.hours_net_amount}}</td>
            <td class="text-center">{{val.month_net_amount}}</td>
            <td class="text-center">{{val.travel_expenses}}</td>
            <td class="text-center">{{val.food_expenses}}</td>
            <td class="text-center">{{val.fuel_expenses}}</td>
            <td class="text-center">{{val.car_rent_expenses}}</td>
            <td class="text-center">{{val.other_expenses}}</td>

          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td><h5>Toplam :</h5></td>
            <td class="text-center">
              <b class="text-center">{{val.expensesTotal.worked_hours}}</b>
              <hr>
            </td>
            <td class="text-center">
              <b>{{val.expensesTotal.hours_net_amount}}</b>
              <hr>
            </td>
            <td class="text-center">
              <b>{{val.expensesTotal.month_net_amount}}</b>
              <hr>
            </td>
            <td class="text-center">
              <b>{{val.expensesTotal.travel_expenses}}</b>
              <hr>
            </td>
            <td class="text-center">
              <b>{{val.expensesTotal.food_expenses}}</b>
              <hr>
            </td>
            <td class="text-center">
              <b>{{val.expensesTotal.fuel_expenses}}</b>
              <hr>
            </td>
            <td class="text-center">
              <b>{{val.expensesTotal.car_rent_expenses}}</b>
              <hr>
            </td>
            <td class="text-center">
              <b>{{val.expensesTotal.other_expenses}}</b>
              <hr>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    -->

  </div>
  <div v-else class="alert alert-info" role="alert">
    Henüz personel seçimi yapılmadı. Yukarıdan personel seçiniz.
  </div>
</template>


<script>
import apiClient from "@/axios";

export default {
  props: {
    selectedPersonal: {
      type: Array,
      default: () => []
    },
    contractId: {
      type: [String, Number],
      required: false
    },
    companyId: {
      type: [String, Number],
      required: false
    },
    contractItems: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  name: "PersonalFieldsComponent",
  data() {
    return {
      activeContractHours: 0,
      contractsVisibility: {},
      collapsedCards: [],
      items: [],
      sgkRateData: [],
      filteredItems: [],
      selectedItem: null,
      showSuggestions: false,
      query: "",
      collapsed: [],
      totalworkedhours: 0,
      workTimeError: false,
      processedIds: new Set(),
      activeContracts: [],
      activeContractsVisibility: {},
      activeContractsData: {},
      loadingPersonalData: false,
      isLoadingPersonalList: false
    };
  },

  computed: {
    averageHourlyRate() {
      if (!this.selectedPersonal || !this.selectedPersonal.length) return 0;
      return (this.selectedPersonal[this.selectedPersonal.length - 1]?.averagehourlyrate || 0).toFixed(2);
    }

  },



  created() {

    console.log('Mevcut seçili personel:', this.selectedPersonal);
    console.log('Personel ID:', this.selectedPersonal?.personalid);


    this.initializeWorkTime();
    this.getData();
    this.getSgkRateData();
    console.log("Gelen contractId:", this.contractId);
    console.log("Gelen companyId:", this.companyId);
    if (this.contractId) {
      this.loadPersonalExpenses();
    }

    /*
    if (this.selectedPersonal && this.selectedPersonal.length > 0) {
      this.selectedPersonal.forEach(personal => {
        this.loadCurrentContract(personal.id);
        this.fetchPersonalExpenses(personal.id);
      });
    }

    // Başlangıçta otomatik olarak workedhours değerini set et
  if (this.selectedPersonal && this.selectedPersonal.length) {
    this.selectedPersonal.forEach(personal => {
      personal.workTime = personal.workedhours;
    });
  }
*/
  },
  mounted() {
    this.getSgkRateData();
  },
  watch: {
    selectedPersonal: {
      deep: true,
      handler(newVal) {
        console.log('Selected Personal:', newVal);

        if (!Array.isArray(newVal)) return;

        newVal.forEach(person => {
          // Mevcut hesaplamalar
          person.netMonthAmount = person.netHourAmount * person.workTime;

          let calculateInsuranceBase = ((person.netHourAmount / 30) * person.insuranceDay);
          if (calculateInsuranceBase > 195041) {
            calculateInsuranceBase = 195041;
          }
          person.insuranceBase = calculateInsuranceBase;

          if (person.workTime && !this.processedIds.has(person.id)) {
            this.updateTotalWorkedHours(person.id);
            this.fetchPersonalExpenses(person.id);
            this.processedIds.add(person.id); // ID'yi işlenmiş olarak işaretle
          }
        });
      }
    },

    contractId: {
      handler(newVal) {
        console.log("contractId değişti:", newVal);
      }
    },

    companyId: {
      immediate: true,
      handler(newVal) {
        console.log('CompanyId değişti:', newVal);
      }
    }
  },
  methods: {
    calculateInsuranceDay(workTime) {
      // Çalışma saatini 8'e böl ve tam sayıya yuvarla
      return Math.floor(workTime / 8);
    },
    calculateSgkBasis(grossSalary) {
      const SGK_CEILING = 195041.40;
      return grossSalary > SGK_CEILING ? SGK_CEILING : grossSalary;
    },

    calculateMaxWorkTime(index) {
      const personal = this.selectedPersonal[index];
      if (!personal) return 0;

      const personalWorkedHours = Number(personal.personalWorkedHours) || 0;
      const activeContractHours = Number(personal.activeContractHours) || 0;

      return Math.max(0, personalWorkedHours - activeContractHours);
    },

    validateInput(e, index) {
      const maxValue = this.calculateMaxWorkTime(index);
      let value = Number(e.target.value);

      if (value < 0) {
        this.selectedPersonal[index].workTime = 0;
      } else if (value > maxValue) {
        this.selectedPersonal[index].workTime = maxValue;
      }
    },


    initializeWorkTime() {
      if (this.selectedPersonal && this.selectedPersonal.length) {
        this.selectedPersonal.forEach((personal, index) => {
          // Doğrudan atama yapıyoruz
          this.selectedPersonal[index].workTime = personal.workedhours || 0;
        });
      }
    },


    remainingWorkTime(index) {
      const person = this.selectedPersonal[index];
      if (!person) return 0;

      // İçe görevlendirme saati
      const assignedHours = Number(person.personalWorkedHours || 0);
      // Aktif sözleşme saati
      const activeContractHours = Number(person.activeContractHours || 0);

      return assignedHours - activeContractHours;
    },

    validateWorkTime(value, index) {
      const maxAllowed = this.remainingWorkTime(index);

      if (value > maxAllowed) {
        return `Çalışma saati, içe görevlendirme saati ile aktif sözleşme saati arasındaki farkı aşamaz.`;
      }

      return true;
    },

    isActiveContractsVisible(index) {
      return this.activeContractsVisibility[index] === true;
    },
    toggleActiveContracts(personalId, index) {
      this.activeContractsVisibility[index] = !this.activeContractsVisibility[index];

      // Eğer görünür hale getirildiyse ve daha önce yüklenmemişse, verileri yükle
      if (this.activeContractsVisibility[index] && (!this.activeContractsData[index] || !this.activeContractsData[index].length)) {
        this.loadActiveContracts(personalId, index);
      }
    },
    loadActiveContracts(personalId, index) {
      apiClient.get(`/personal-expenses/active-contracts/${personalId}`)
          .then((response) => {
            if (Array.isArray(response.data)) {
              this.activeContractsData[index] = response.data; // this.$set yerine doğrudan atama
            } else {
              this.activeContractsData[index] = []; // this.$set yerine doğrudan atama
            }
          })
          .catch((error) => {
            console.error("Aktif sözleşmeler yüklenirken hata:", error);
            alert("Aktif sözleşme bilgileri yüklenemedi.");
            this.activeContractsData[index] = []; // this.$set yerine doğrudan atama
          });
    },



    calculateTotalFoodExpenses(personalId) {
      const personal = this.selectedPersonal.find(p => p.id === personalId);
      if (!personal || !personal.previousContracts) return 0;

      return personal.previousContracts.reduce((total, contract) => {
        return total + (contract.foodExpenses || 0);
      }, 0);
    },

    calculateTotalCarRentExpenses(personalId) {
      const personal = this.selectedPersonal.find(p => p.id === personalId);
      if (!personal || !personal.previousContracts) return 0;

      return personal.previousContracts.reduce((total, contract) => {
        return total + (contract.carRentExpenses || 0);
      }, 0);
    },

    calculateTotalFuelExpenses(personalId) {
      const personal = this.selectedPersonal.find(p => p.id === personalId);
      if (!personal || !personal.previousContracts) return 0;

      return personal.previousContracts.reduce((total, contract) => {
        return total + (contract.fuelExpenses || 0);
      }, 0);
    },

    calculateTotalOtherExpenses(personalId) {
      const personal = this.selectedPersonal.find(p => p.id === personalId);
      if (!personal || !personal.previousContracts) return 0;

      return personal.previousContracts.reduce((total, contract) => {
        return total + (contract.otherExpenses || 0);
      }, 0);
    },

    calculateTotalTravelExpenses(personalId) {
      const personal = this.selectedPersonal.find(p => p.id === personalId);
      if (!personal || !personal.previousContracts) return 0;

      return personal.previousContracts.reduce((total, contract) => {
        return total + (contract.travelExpenses || 0);
      }, 0);
    },
    isContractsVisible(index) {
      return this.contractsVisibility[index] === true;
    },
    togglePreviousContracts(personalId, index) {
      this.contractsVisibility[index] = !this.contractsVisibility[index];

      // Eğer görünür hale getirildiyse ve daha önce yüklenmemişse, verileri yükle
      if (this.contractsVisibility[index] && (!this.selectedPersonal[index].previousContracts || !this.selectedPersonal[index].previousContracts.length)) {
        this.loadPreviousContracts(personalId, index);
      }
    },
    loadCurrentContract(personalId) {
      const companyId = this.companyId;

      if (!companyId || !personalId) {
        console.error("Eksik parametreler:", { companyId, personalId });
        return;
      }

      apiClient
          .get(`/personal-expenses/${personalId}`)
          .then((response) => {
            const currentContract = response.data;

            // Form alanlarını doldur
            const index = this.selectedPersonal.findIndex(p => p.id === personalId);
            if (index !== -1) {
              this.selectedPersonal[index] = {
                ...this.selectedPersonal[index],
                carRentExpenses: currentContract.carRentExpenses,
                foodExpenses: currentContract.foodExpenses,
                fuelExpenses: currentContract.fuelExpenses,
                hoursNetAmount: currentContract.hoursNetAmount,
                insuranceBase: currentContract.insuranceBase,
                insuranceDay: currentContract.insuranceDay,
                insuranceRate: currentContract.insuranceRateId,
                monthNetAmount: currentContract.monthNetAmount,
                otherExpenses: currentContract.otherExpenses,
                personalEndDate: this.formatDate(currentContract.personalEndDate),
                personalStartDate: this.formatDate(currentContract.personalStartDate),
                replacementService: currentContract.replacementService,
                seniorityBurden: currentContract.seniorityBurden,
                travelExpenses: currentContract.travelExpenses,
                workTime: currentContract.workedHours,
                contractName: currentContract.contracts?.contractName,
                personalExpenses: {
                  ...this.selectedPersonal[index].personalExpenses,
                  currentContracts: currentContract.currentContracts || [] // Aktif sözleşmeleri ekleyin
                },
                personalWorkedHours: currentContract.personalworkedhours || 0 // Eklendi
              };

              // totalActiveContractHours bilgisini çek
              this.loadTotalActiveContractHours(personalId, index);

              // personalWorkedHours bilgisini çek
              this.loadPersonalWorkedHours(personalId, index);
            }
          })
          .catch((error) => {
            console.error("Mevcut sözleşme bilgileri yüklenirken hata:", error);
          });
    },
    loadPersonalWorkedHours(personalId, index) {
      // selectedPersonal ve index kontrolü (güvenlik için)
      if (!this.selectedPersonal || !this.selectedPersonal[index]) {
        console.warn(`loadPersonalWorkedHours: selectedPersonal at index ${index} (ID: ${personalId}) bulunamadı.`);
        if (this.selectedPersonal && index < this.selectedPersonal.length && index >=0) { // Eğer index geçerli ama obje undefined ise
          this.selectedPersonal[index].personalWorkedHours = 0;
          if (this.selectedPersonal[index].personalExpenses && this.selectedPersonal[index].personalExpenses.personal) {
            if (!this.selectedPersonal[index].personalExpenses.personal.role) {
              // Vue 2 için: this.$set(this.selectedPersonal[index].personalExpenses.personal, 'role', { roleName: null });
              this.selectedPersonal[index].personalExpenses.personal.role = { roleName: null };
            } else {
              // Vue 2 için: this.$set(this.selectedPersonal[index].personalExpenses.personal.role, 'roleName', null);
              this.selectedPersonal[index].personalExpenses.personal.role.roleName = null;
            }
          }
        }
        return Promise.resolve();
      }

      const personAtIndex = this.selectedPersonal[index];

      return apiClient
          .get(`/personal-expenses/worked-hours/${personalId}`)
          .then((response) => {
            // 1. İçe Görevlendirme Saati (personalWorkedHours) güncellemesi
            const workedHours = response.data.personalworkedhours || 0;
            personAtIndex.personalWorkedHours = workedHours; // Ana obje üzerinde doğrudan atama

            // personalExpenses yapısının varlığından emin ol (roleName için gerekli)
            if (!personAtIndex.personalExpenses) {
              // Vue 2 için: this.$set(personAtIndex, 'personalExpenses', {});
              personAtIndex.personalExpenses = {};
            }
            if (!personAtIndex.personalExpenses.personal) {
              // Vue 2 için: this.$set(personAtIndex.personalExpenses, 'personal', {});
              personAtIndex.personalExpenses.personal = {};
            }
            // Tutarlılık için personalworkedhours'ı personalExpenses.personal içinde de güncelleyebiliriz (opsiyonel)
            // Vue 2 için: this.$set(personAtIndex.personalExpenses.personal, 'personalworkedhours', workedHours);
            personAtIndex.personalExpenses.personal.personalworkedhours = workedHours;


            // 2. Role Adı (roleName) güncellemesi
            const apiRoleName = response.data.rolename || null; // API'den gelen rol adı, yoksa null

            // personalExpenses.personal.role yapısının varlığından emin ol
            if (!personAtIndex.personalExpenses.personal.role) {
              // Vue 2 için: this.$set(personAtIndex.personalExpenses.personal, 'role', {});
              personAtIndex.personalExpenses.personal.role = {};
            }
            // Her zaman bu API'den gelen roleName'i ata
            // Vue 2 için: this.$set(personAtIndex.personalExpenses.personal.role, 'roleName', apiRoleName);
            personAtIndex.personalExpenses.personal.role.roleName = apiRoleName;

          })
          .catch((error) => {
            console.error(`İçe görevlendirme saati ve rol (ID: ${personalId}) yüklenirken hata:`, error);
            // Hata durumunda varsayılan değerleri ata
            personAtIndex.personalWorkedHours = 0;

            // Role için de hata durumunda null ata
            if (personAtIndex.personalExpenses && personAtIndex.personalExpenses.personal) {
              if (!personAtIndex.personalExpenses.personal.role) {
                // Vue 2 için: this.$set(personAtIndex.personalExpenses.personal, 'role', { roleName: null });
                personAtIndex.personalExpenses.personal.role = { roleName: null };
              } else {
                // Vue 2 için: this.$set(personAtIndex.personalExpenses.personal.role, 'roleName', null);
                personAtIndex.personalExpenses.personal.role.roleName = null;
              }
            }
          });
    },
    loadTotalActiveContractHours(personalId, index) {
      console.log("loadTotalActiveContractHours - personalId:", personalId, "index:", index);
      apiClient
          .get(`/personal-expenses/total-active-hours/${personalId}`)
          .then((response) => {
            console.log("API Yanıtı:", response.data);
            // API'den gelen totalworkedhours değerini activeContractHours'a atıyoruz
            this.selectedPersonal[index].activeContractHours = response.data.totalworkedhours || 0;
            console.log("Güncellenmiş selectedPersonal:", this.selectedPersonal[index]);
          })
          .catch((error) => {
            console.error("Toplam aktif sözleşme saati yüklenirken hata:", error);
            this.selectedPersonal[index].activeContractHours = 0;
          });
    },

    loadPreviousContracts(personalId, index) {
      // companyId kontrolü
      const companyId = this.companyId;

      if (!companyId || !personalId) {
        console.error("Gerekli parametreler eksik:", {
          companyId: this.companyId,
          personalId: personalId
        });
        alert("Geçmiş sözleşmeleri yüklemek için gerekli bilgiler eksik!");
        return;
      }

      // Yükleme durumunu güncelle
      this.selectedPersonal[index].loadingPreviousContracts = true;

      // API çağrısı
      apiClient
          .get(`/personal-expenses/previous/${companyId}/${personalId}`)
          .then((response) => {
            if (Array.isArray(response.data)) {
              this.selectedPersonal[index].previousContracts = response.data;
            } else {
              this.selectedPersonal[index].previousContracts = [];
            }
          })
          .catch((error) => {
            console.error("Geçmiş sözleşmeler yüklenirken hata:", error);
            alert("Geçmiş sözleşme bilgileri yüklenemedi.");
            this.selectedPersonal[index].previousContracts = [];
          })
          .finally(() => {
            this.selectedPersonal[index].loadingPreviousContracts = false;
          });
    },

    deleteExpense(index) {
      const person = this.selectedPersonal[index];
      if (!person?.personalExpenses?.id) {
        alert("Silinecek kayıt bulunamadı!");
        return;
      }

      if (confirm("Bu personel gider kaydını silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.")) {
        apiClient.delete(`/personal-expenses/${person.personalExpenses.id}`)
            .then(() => {
              // Query parametreleri ile endpoint'i çağırma
              return apiClient.put(`/project-profitability/soft-delete?personalId=${person.id}&contractId=${this.contractId}`);
            })
            .then(() => {
              this.selectedPersonal.splice(index, 1);
              alert("Personel gider kaydı başarıyla silindi.");
              this.loadPersonalExpenses();
            })
            .catch(error => {
              console.error("Silme işlemi sırasında hata:", error);
              alert("Silme işlemi sırasında bir hata oluştu: " + (error.response?.data || error.message));
            });
      }
    },


    updateTotalWorkedHours(personalId) {
      const person = this.selectedPersonal.find(p => p.id === personalId);
      if (person) {
        // Geçmiş sözleşmelerdeki toplam saati hesapla
        const previousHours = person.previousContracts
            ? person.previousContracts.reduce((sum, contract) => sum + (Number(contract.workedHours) || 0), 0)
            : 0;

        // Mevcut çalışma saatini ekle
        const currentHours = Number(person.workTime) || 0;

        // Toplam saati güncelle
        person.totalworkedhours = previousHours + currentHours;
      }
    },
    loadPersonalExpenses() {
      this.isLoadingPersonalList = true;
      return apiClient.get(`/personal-expenses/mongodb-active-contract/${this.contractId}`)
          .then(response => {
            if (response.data && response.data.length > 0) {
              const mappedData = response.data
                  .filter(expense => expense.personalid !== null)
                  .map(expense => ({
                    id: expense.personalid,
                    name: expense.personalname,
                    personalExpenses: {
                      id: expense.personalexpenseid,
                      personal: {
                        id: expense.personalid,
                        name: expense.personalname,
                        workOrRetired: expense.workorretired,
                        workType: expense.worktype,
                        role: {
                          roleName: expense.personalrolename
                        },
                        personalworkedhours: expense.personalworkedhours // İçe Görevlendirme Saati ekleniyor
                      }
                    },
                    travelExpenses: expense.travelexpenses,
                    foodExpenses: expense.foodexpenses,
                    fuelExpenses: expense.fuelexpenses,
                    carRentExpenses: expense.carrentexpenses,
                    otherExpenses: expense.otherexpenses,
                    netHourAmount: expense.hoursnetamount,
                    workTime: expense.workedhours,
                    netMonthAmount: expense.monthnetamount,
                    replacementService: expense.replacementservice,
                    seniorityBurden: expense.seniorityburden,
                    insuranceDay: expense.insuranceday,
                    insuranceBase: expense.insurancebase,
                    invoiceAmount: expense.invoiceamount || 0,
                    personalStartDate: this.formatDate(expense.personalstartdate),
                    personalEndDate: this.formatDate(expense.personalenddate),
                    insuranceRate: expense.personalinsurancerateid,
                    personalWorkedHours: expense.personalworkedhours || 0 // Eklendi
                  }));

              this.$emit('update:selectedPersonal', mappedData);
              this.collapsed = new Array(mappedData.length).fill(false);

              // Her personel için totalActiveContractHours ve rol bilgisini yükle
              mappedData.forEach((person, index) => {
                this.loadTotalActiveContractHours(person.id, index);
                this.loadPersonalWorkedHours(person.id, index);
              });

              // Personel listesini döndür (personelin listede olup olmadığını kontrol etmek için)
              return mappedData;
            } else {
              // Aktif personel yoksa, selectedPersonal'ı boşalt ve sözleşme tutarını 0 yap
              this.$emit('update:selectedPersonal', []);
              this.collapsed = [];

              // Sözleşme tutarını 0 olarak güncelle
              this.$emit('contract-price-updated', 0);

              // Backend'de sözleşme tutarını güncelle
              this.recalculateContractPrice();

              console.log('No active personnel found for contract, contract price set to 0');
              
              // Boş liste döndür
              return [];
            }
          })
          .catch(error => {
            console.error('Aktif personel giderleri yüklenirken hata:', error);
            alert('Aktif personel giderleri yüklenirken bir hata oluştu.');
            // Hata durumunda yükleme barını kapat
            this.loadingPersonalData = false;
            return [];
          })
          .finally(() => {
            this.isLoadingPersonalList = false;
          });
    },

// Tarihi formatlama için yardımcı metod
    formatDate(timestamp) {
      if (!timestamp) return null;
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0]; // YYYY-MM-DD formatında
    },
    saveChanges(index) {
      const person = this.selectedPersonal[index];

      if (!person || !person.id) {
        alert("Kayıt edilecek personel bilgisi eksik!");
        return;
      }

      const contractId = person.contractId || this.contractId;

      if (!contractId) {
        alert("Sözleşme ID bulunamadı. Güncelleme işlemi iptal edildi.");
        console.error("Eksik contractId, güncelleme yapılamaz:", person);
        return;
      }

      // Görev bitiş tarihini kontrol et
      const endDate = person.personalEndDate ? new Date(person.personalEndDate) : null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      // Eğer endDate varsa, sadece tarih kısmını karşılaştır (saat bilgisi olmadan)
      let shouldShowLoading = false;
      if (endDate) {
        const endDateOnly = new Date(endDate);
        endDateOnly.setHours(0, 0, 0, 0);
        // Bugünün tarihi veya geçmiş bir tarih ise yükleme barını göster
        if (endDateOnly <= today) {
          shouldShowLoading = true;
        }
      }

      const payload = {
        personal: { id: person.id },
        contracts: { id: contractId },
        travelExpenses: person.travelExpenses || 0,
        foodExpenses: person.foodExpenses || 0,
        fuelExpenses: person.fuelExpenses || 0,
        carRentExpenses: person.carRentExpenses || 0,
        otherExpenses: person.otherExpenses || 0,
        hoursNetAmount: person.netHourAmount || 0,
        workedHours: person.workTime || 0,
        monthNetAmount: person.netMonthAmount || 0,
        replacementService: person.replacementService || false,
        seniorityBurden: person.seniorityBurden || false,
        personalStartDate: person.personalStartDate
            ? new Date(person.personalStartDate).getTime()
            : null,
        personalEndDate: person.personalEndDate
            ? new Date(person.personalEndDate).getTime()
            : null,
        insuranceDay: person.insuranceDay || 0,
        insuranceBase: person.insuranceBase || 0,
        invoiceAmount: person.invoiceAmount || 0,
        insuranceRateId: typeof person.insuranceRate === 'object'
            ? person.insuranceRate.id
            : person.insuranceRate || null
      };

      // Mevcut kayıt varsa güncelle, yoksa yeni kayıt oluştur
      const method = person.personalExpenses?.id ? 'put' : 'post';
      const url = person.personalExpenses?.id
          ? `/personal-expenses/${person.personalExpenses.id}`
          : '/personal-expenses';

      // Her zaman yükleme göstergesini göster
      this.loadingPersonalData = true;

      apiClient[method](url, payload)
          .then(response => {
            alert(method === 'put'
                ? "Personel masrafları başarıyla güncellendi."
                : "Personel masrafları başarıyla kaydedildi.");

            // Personel verilerini yeniden yükle
            // Eğer bugünün tarihi girildiyse, yükleme barı zaten açık
            // Personel listeden kaldırılana kadar yükleme barı görünecek
            if (shouldShowLoading) {
              this.loadPersonalExpenses().then((mappedData) => {
                // Personelin listeden kaldırılıp kaldırılmadığını kontrol et
                const personStillInList = mappedData.some(p => p.id === person.id);
                
                if (!personStillInList) {
                  // Personel listeden kaldırıldı, yükleme barını kapat
                  this.loadingPersonalData = false;
                } else {
                  // Personel hala listede, biraz daha bekle ve tekrar kontrol et
                  setTimeout(() => {
                    this.checkAndCloseLoadingBar(person.id);
                  }, 1000);
                }
              });
            } else {
              // İleri tarih girildi, normal güncelleme yap
              this.loadPersonalExpenses().then(() => {
                // Toplam aktif sözleşme saati bilgisini güncelle
                this.loadTotalActiveContractHours(person.id, index);

                // İçe görevlendirme saatlerini ve rol bilgisini yeniden yükle
                this.loadPersonalWorkedHours(person.id, index);
              }).finally(() => {
                // Veriler yüklendikten sonra yükleme göstergesini kapat
                this.loadingPersonalData = false;
              });
            }

            // Parent component'e personel güncellendiğini bildir (Dashboard güncellemesi için)
            this.$emit('personal-expense-updated');

            // Global event dispatch et (Dashboard için)
            window.dispatchEvent(new CustomEvent('personal-expense-updated'));
          })
          .catch(error => {
            console.error("İşlem hatası:", error);
            alert("İşlem sırasında bir hata oluştu: " + error.message);
            this.loadingPersonalData = false;
          });
    },
    checkAndCloseLoadingBar(personalId) {
      // Personel verilerini tekrar yükle ve kontrol et
      this.loadPersonalExpenses().then((mappedData) => {
        // Personelin listeden kaldırılıp kaldırılmadığını kontrol et
        const personStillInList = mappedData.some(p => p.id === personalId);
        
        if (!personStillInList) {
          // Personel listeden kaldırıldı, yükleme barını kapat
          this.loadingPersonalData = false;
        } else {
          // Personel hala listede, tekrar kontrol et
          setTimeout(() => {
            this.checkAndCloseLoadingBar(personalId);
          }, 1000);
        }
      });
    },
    removeCard(index) {
      if (this.selectedPersonal && this.selectedPersonal.length > index) {
        this.selectedPersonal.splice(index, 1);
      }
    },
    toggleCollapse(index) {
      this.collapsed[index] = !this.collapsed[index];
    },
    isCollapsed(index) {
      return this.collapsed[index] !== true;
    },
    getTotalAmount(index) {
      const person = this.selectedPersonal[index];
      return person.netHourAmount * person.workTime;
    },
    addPersonal() {
      if (!Array.isArray(this.selectedPersonal)) {
        console.error("selectedPersonal dizisi geçersiz!");
        return;
      }
      if (!this.selectedItem || !this.selectedItem.personal || !this.selectedItem.personal.id) {
        alert("Geçerli bir öğe seçmediniz!");
        return;
      }
      const exists = this.selectedPersonal.some(
          (item) => item.id === this.selectedItem.personal.id
      );
      if (exists) {
        alert("Bu öğe zaten mevcut");
      } else {
        let item = {
          id: this.selectedItem.personal.id,
          name: this.selectedItem.personal.name,
          workInfo: this.selectedItem.personal.workinfo || null,
          personalExpenses: {
            personal: {
              id: this.selectedItem.personal.id,
              name: this.selectedItem.personal.name,
              workOrRetired: this.selectedItem.personal.workOrRetired,
              workType: this.selectedItem.personal.workType,
              role: {
                roleName: this.selectedItem.personal.roleName || (this.selectedItem.personal.role ? this.selectedItem.personal.role.roleName : null)
              },
              personalworkedhours: this.selectedItem.personal.personalworkedhours || 0 // Varsayılan olarak 0 ata
            }
          },
          travelExpenses: this.selectedItem.travelExpenses || 0,
          foodExpenses: this.selectedItem.foodExpenses || 0,
          fuelExpenses: this.selectedItem.fuelExpenses || 0,
          carRentExpenses: this.selectedItem.carRentExpenses || 0,
          otherExpenses: this.selectedItem.otherExpenses || 0,
          netHourAmount: this.selectedItem.hoursNetAmount || 0,
          netMonthAmount: this.selectedItem.monthNetAmount || 0,
          insuranceBase: this.selectedItem.insuranceBase || 0,
          insuranceDay: this.selectedItem.insuranceDay || 0,
          invoiceAmount: this.selectedItem.invoiceAmount || 0,
          insuranceRate: this.selectedItem.insuranceRate?.sgkRate || 0,
          replacementService: this.selectedItem.replacementService || false,
          seniorityBurden: this.selectedItem.seniorityBurden || false,
          workTime: this.selectedItem.workedHours || 0,
          personalStartDate: this.selectedItem.personalStartDate || null,
          personalEndDate: this.selectedItem.personalEndDate || null,
          totalworkedhours: 0, // Varsayılan olarak 0 ata
          personalWorkedHours: 0, // Varsayılan olarak 0 ata
          averagehourlyrate: 0 // Varsayılan olarak 0 ata
        };

        this.selectedPersonal.push(item);
        this.collapsedCards.push(false);

        // Yeni eklenen personelin totalActiveContractHours bilgisini yükle
        const newIndex = this.selectedPersonal.length - 1;
        this.fetchPersonalExpenses(item.id); // averagehourlyrate değerini çekmek için
        this.loadTotalActiveContractHours(item.id, newIndex);
        this.loadPersonalWorkedHours(item.id, newIndex); // Yeni eklenen satır

      }

      this.query = "";
    },
    filterItems() {
      const queryLower = this.query.toLowerCase();
      this.filteredItems = this.items.filter((item) => {
        return item?.name?.toLowerCase().includes(queryLower);
      });
    },
    fetchPersonalExpenses(personalId) {
      console.log('fetchPersonalExpenses çağrıldı, personalId:', personalId);
      return apiClient.get(`/personal-expenses/total-hours-net-amount/${personalId}`)
          .then(response => {
            console.log('API yanıtı:', response.data);
            if (response.data) {
              // averagehourlyrate değerini selectedPersonal dizisindeki ilgili nesneye ekliyoruz
              const index = this.selectedPersonal.findIndex(p => p.id === personalId);
              if (index !== -1) {
                this.selectedPersonal[index].averagehourlyrate = response.data.averagehourlyrate;
              }
              return response.data;
            }
          })
          .catch(error => {
            console.error('Hata:', error);
            return Promise.reject(error);
          });
    },

    selectItem(item) {
      this.query = item.name;
      this.selectedItem = {personal: item}; // Uyumlu hale getiriyoruz
      this.showSuggestions = false;
      this.fetchPersonalExpenses(item.id);

      // Personel rolü bilgisini doğru şekilde ata
      if (item.role && item.role.roleName) {
        this.selectedItem.personal.roleName = item.role.roleName;
      }
    },
    hideSuggestions() {
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200);
    },
    getData() {
      this.isLoadingPersonalList = true;
      // MongoDB'de proje karlılık kaydı olan personelleri getir
      apiClient.get("/personal/dashboard-with-profitability")
          .then((res) => {
            console.log("MongoDB'de kaydı olan personel listesi:", res.data);
            this.items = res.data;
            this.isLoadingPersonalList = false;
          })
          .catch((err) => {
            console.error("Personel verisi alınırken hata:", err);
            // Hata durumunda fallback olarak tüm personelleri getir
            apiClient.get("/personal")
                .then((res) => {
                  console.log("Fallback - Tüm personel listesi:", res.data);
                  this.items = res.data;
                  this.isLoadingPersonalList = false;
                })
                .catch((fallbackErr) => {
                  console.error("Fallback personel verisi alınırken hata:", fallbackErr);
                  this.isLoadingPersonalList = false;
                });
          });
    },
    getSgkRateData() {
      apiClient.get("/sgkRate").then((res) => {
        this.sgkRateData = res.data;
      });
    },
    deletePersonal(id) {
      console.log("id", id)
      this.selectedPersonal = this.selectedPersonal.filter(
          (item) => item.id !== id
      );
    },
    recalculateContractPrice() {
      if (this.contractId) {
        apiClient.post(`/contract/${this.contractId}/recalculate-price`)
            .then(response => {
              console.log('Contract price recalculated:', response.data);
            })
            .catch(error => {
              console.error('Error recalculating contract price:', error);
            });
      }
    },
    formatCurrency(value) {
      if (value !== undefined && value !== null) {
        return new Intl.NumberFormat("tr-TR", {
          style: "currency",
          currency: "TRY",
        }).format(value); // TL formatında döndürme
      }
      return "₺0,00"; // Eğer değer boşsa, varsayılan bir değer döndür
    },
    calculateActiveContractTotalWorkedHours(contracts) {
      return contracts?.reduce((total, contract) => {
        return total + (Number(contract.workedhours) || 0);
      }, 0);
    },

    calculateActiveContractTotalFoodExpenses(contracts) {
      const total = contracts?.reduce((total, contract) => {
        return total + (Number(contract.foodexpenses) || 0);
      }, 0);
      return this.formatCurrency(total);
    },

    calculateActiveContractTotalCarRentExpenses(contracts) {
      const total = contracts?.reduce((total, contract) => {
        return total + (Number(contract.carrentexpenses) || 0);
      }, 0);
      return this.formatCurrency(total);
    },

    calculateActiveContractTotalFuelExpenses(contracts) {
      const total = contracts?.reduce((total, contract) => {
        return total + (Number(contract.fuelexpenses) || 0);
      }, 0);
      return this.formatCurrency(total);
    },

    calculateActiveContractTotalOtherExpenses(contracts) {
      const total = contracts?.reduce((total, contract) => {
        return total + (Number(contract.otherexpenses) || 0);
      }, 0);
      return this.formatCurrency(total);
    },

    calculateActiveContractTotalTravelExpenses(contracts) {
      const total = contracts?.reduce((total, contract) => {
        return total + (Number(contract.travelexpenses) || 0);
      }, 0);
      return this.formatCurrency(total);
    },
  },
};
</script>


<style>
.suggestions {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
  background: white;
}

.suggestion-item {
  padding: 8px;
  cursor: pointer;
}

.suggestion-item:hover {
  background-color: #f0f0f0;
}

.shadow-box {
  width: 400px;
  height: 150px;
  padding: 5px;
  text-align: left;
  font-family: Arial, sans-serif;
  font-size: 16px;
}
</style>

<style scoped>
input[type="date"] {
  appearance: none;
  -webkit-appearance: none;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 16px;
  font-family: 'Arial', sans-serif;
  color: #333;
  outline: none;
  transition: all 0.3s ease;


  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

input[type="date"]:hover {
  border-color: #888;
  background-color: #f0f0f0;
}

input[type="date"]:focus {
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.5);
  background-color: #fff;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  cursor: pointer;
  filter: invert(0.5);
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

input[type="date"]::-webkit-calendar-picker-indicator:hover {
  opacity: 1;
}

.personalExpensesDiv {
  background-color: #ffffff;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.15);
  border-radius: 9px;
  border: #756d6d solid 1px;
  padding: 20px;
  margin-top: 10px;
}

.centered-text {
  display: flex;
  width: 100%;
  margin-top: 25px;
}

.load-contracts-btn {
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 6px;
  transition: all 0.3s ease;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 200px;
}

.load-contracts-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.personal-info {
  flex: 1;
  padding-right: 20px;
}

.centered-text {
  display: flex;
  width: 100%;
  margin: 15px 0;
  align-items: center;
}

/* personalExpensesDiv'i güncelleyelim */
.personalExpensesDiv {
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  padding: 20px;
  margin-top: 15px;
  transition: all 0.3s ease;
}

.personalExpensesDiv:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.load-contracts-btn {
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 6px;
  transition: all 0.3s ease;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.load-contracts-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.contracts-container {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  margin-top: 10px;
  border: 1px solid #e9ecef;
}

.previous-contracts {
  animation: fadeIn 0.3s ease-in-out;
}

.table {
  margin-bottom: 0;
  background-color: white;
  border-radius: 6px;
}

.table th {
  font-weight: 600;
  font-size: 14px;
}

.table td {
  font-size: 14px;
  vertical-align: middle;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.personal-info {
  flex: 1;
  padding-right: 20px;
}

.centered-text {
  display: flex;
  width: 100%;
  margin: 15px 0;
  align-items: center;
}

.personalExpensesDiv {
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  padding: 20px;
  margin-top: 15px;
  transition: all 0.3s ease;
}

.table th,
.table td {
  text-align: center; /* Metni ortalar */
  vertical-align: middle; /* Dikeyde ortalar */
}

.table tr.total-row {
  background-color: #f8f9fa; /* Arkaplan rengi */
  font-weight: bold; /* Kalın yazı */
}

.list-group {
  position: absolute;
  z-index: 1000;
  width: 300px;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-content p {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
</style>
